import React, { useContext, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getToken } from '../../utils/token';
import { authSelectors } from '../../store/selectors/auth';
import { continueTestThunk, getTestThunk } from '../../store/thunks/test';
import { testSelectors } from '../../store/selectors/test';
import { LayoutContext } from '../../contexts/layout.context';
import { useNavigate } from 'react-router-dom';
import actions from '../../store/actions';
import Head from '../../components/Head/Head';
import Progressbar from '../../common/Progress/Progressbar';
import TestQuestion from '../../components/Test/TestQuestion';
import Spinner from '../../common/Spinner/Spinner';
import ModalTest from '../../components/ModalTest/ModalTest';
import TestTypeAnswers from '../../components/Test/TestTypeAnswers';
import TestTranslate from '../../components/Test/TestTranslate';
import TestConformity from '../../components/Test/TestConformity';
import TestSpeak from '../../components/Test/TestSpeak';
import { getUserInfoThunk } from '../../store/thunks/profile';
import usePreviewFeature from '../../hooks/usePreviewFeature';
import './test-compact.scss';
import { enterTestStage, resetTestStage } from '../../utils/testStage';

const Test = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { setLayout } = useContext(LayoutContext);

  const homeworkId = JSON.parse(localStorage.getItem('homeworkElId'));
  const currenBlockId = JSON.parse(localStorage.getItem('homeworkId'));
  const currentTestId = JSON.parse(localStorage.getItem('currentTestId'));
  const auth = useSelector(authSelectors);
  const token = auth.token;
  const test = useSelector(testSelectors);
  const testInfo = test.test;
  const type = test.type;
  const load = test.load;
  const finished = test.finished;
  const isRedesign = usePreviewFeature('courses-redesign');

  const [openModal, setOpenModal] = useState(false);
  const [isStartTest, setIsStartTest] = useState(JSON.parse(localStorage.getItem('startTest')));
  const staleFinishedRef = useRef(finished);
  const stageRef = useRef(null);

  getToken();

  useEffect(() => {
    document.title = 'Тест | New Brain';
    setLayout({ page: 'Тест' });
  }, [setLayout]);

  useEffect(() => {
    if (token) {
      dispatch(getUserInfoThunk({ token }));
    }
  }, [token]);

  useEffect(() => {
    dispatch(actions.test.finishedTest({}));
  }, []);

  useEffect(() => {
    if (isStartTest && homeworkId && currenBlockId && token) {
      // Старий currentTestId міг лишитись від попереднього блока: F5 у момент
      // старту підхоплював його і відкривав чужий блок замість нового.
      localStorage.removeItem('currentTestId');
      const data = { homeworkId, blockId: currenBlockId, token };
      dispatch(getTestThunk(data));
      setIsStartTest(false);
      localStorage.removeItem('startTest');
    }
  }, [token]);

  useEffect(() => {
    if (!isStartTest && currentTestId && token) {
      const data = { id: currentTestId, token };
      dispatch(continueTestThunk(data));
    }
  }, [token]);

  useEffect(() => {
    if (!isStartTest && !currentTestId) {
      // Нема ні нового старту, ні активної спроби (наприклад, F5 у момент
      // старту) — повертаємось до списку завдань замість порожнього екрана.
      navigate('/homework');
    }
  }, []);

  useEffect(() => {
    if (testInfo?.el_homework_block_id) {
      localStorage.setItem('currentTestId', JSON.stringify(testInfo.el_homework_block_id || 0));
    }
  }, [testInfo]);

  useEffect(() => {
    if (finished?.is_finished && finished !== staleFinishedRef.current) {
      navigate('/homework/test/finish');
    }
  }, [finished]);

  const goBack = (currentTestId) => {
    localStorage.removeItem('homeworkId');
    localStorage.removeItem('homeworkElId');
    localStorage.removeItem('homeworkBlockId');
    localStorage.setItem('currentTestId', JSON.stringify(currentTestId || 0));
    localStorage.removeItem('answersArr');
    localStorage.removeItem('definitionArr');
    dispatch(actions.test.getTest({}));
    dispatch(actions.test.getTestType(''));
    dispatch(actions.test.getTestAnswers([]));
    dispatch(actions.test.checkTest({}));
    dispatch(actions.test.getTestError(''));
    navigate('/homework');
  };

  useEffect(() => {
    const stage = stageRef.current;
    if (!stage || !testInfo?.homework_task_id) return undefined;

    enterTestStage(stage);

    const timer = setTimeout(() => stage.classList.remove('is-entering'), 1000);

    return () => clearTimeout(timer);
  }, [testInfo]);

  useEffect(() => {
    if (test.error) {
      resetTestStage(stageRef.current);
    }
  }, [test.error]);

  return (
    load ? <Spinner /> :
      <div className={`test container ${isRedesign ? 'test--compact' : ''}`.trim()}>
        <ModalTest token={token} openModal={openModal} setOpenModal={setOpenModal} />
        <Head
          textHead={testInfo.el_homework_block_title}
          subtitle={`${testInfo.program_name} - ${testInfo.lesson_name} - ${testInfo.homework_block_name}`}
          goBack={() => goBack(testInfo.el_homework_block_id)}
        />
        <div className="test__container" ref={stageRef}>
          <Progressbar testInfo={testInfo} />

          <div className="test__question">
            <TestQuestion
              title={testInfo.el_homework_block_description}
              question={testInfo.homework_task_name}
              videoLink={testInfo.homework_block_video_link}
              conformity={type === 'conformity' ? true : false}
              lang={testInfo.tts_lang}
              wordTest={Boolean(testInfo.is_word_test)}
            />
          </div>
          {type === 'conformity' && <TestConformity setOpenModal={setOpenModal} />}
          {type === 'translate' && <TestTranslate setOpenModal={setOpenModal} />}
          {type === 'test' && <TestTypeAnswers setOpenModal={setOpenModal} />}
          {type === 'speak' && <TestSpeak setOpenModal={setOpenModal} />}
        </div>
      </div >
  );
};

export default Test;